module.exports = __webpack_public_path__ + "img/menu_tab.4afa1592.svg";